import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import i18next from "i18next";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { getPartnersMiniInfo } from "../../../../info/allAirlines";

import { Title, Wrapper } from "./style";

import "../../../swiper/swiper.css";

export const PartnersSwiperComponent = () => {
  const { t, language } = i18next;

  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const getPartners = async () => {
      const result = await getPartnersMiniInfo(0);

      setPartners(result);
    };

    getPartners();
  }, []);

  return (
    <Wrapper>
      {language === "ru" ? (
        <Title style={{ fontFamily: "Pacifico, serif" }}>{t("partners")}</Title>
      ) : (
        <Title>{t("partners")}</Title>
      )}
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        spaceBetween={1}
        slidesPerView={3}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        breakpoints={{
          300: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          830: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1040: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1530: {
            slidesPerView: 4,
            spaceBetween: 60,
          },
        }}
        draggable={true}
        pagination={{ clickable: true }}
        ssMode={true}
        mousewheel={true}
        keyboard={true}
        className={"swiper_container"}
      >
        {partners.map(item => {
          return (
            <SwiperSlide key={item.key} className="swiperSlide">
              <Link to={`airlines/${item.key}`}>
                <img src={item.imageUrl} alt={item.name[language]} />
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Wrapper>
  );
};
